export default __webpack_public_path__ + "2ca4dfc261fc565db9287877e5e8deda.png";